<template>
  <div class="dashboard">
    <MenuBarBidang
        :bidang="bidang"
    />
    <HomeBidang
        :bidang="bidang"
    ></HomeBidang>
    <PublicFooter v-if="!currentUserWebinar"></PublicFooter>
  </div>
</template>

<script>
import PublicFooter from "@/components/AppFooter.vue";
import HomeBidang from "@/components/public-home/HomeBidang.vue";
import MenuBarBidang from "@/components/MenuBarBidang.vue";
import FDivisionService from "@/services/apiservices/f-division-service";
import ERole from "@/models/e-role";

export default {
  name: "HomeBidangView",
  components: {
    MenuBarBidang,
    HomeBidang,
    PublicFooter,
  },
  data() {
    return {
      bidang: undefined,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentUserWebinar(){
      if(this.$store.state.auth.user){
        if(this.$store.state.auth.user.roles.includes(ERole.ROLE_USER)){
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
  },
  mounted() {
    const routePathId = this.$route.params.id;
    FDivisionService.getAllFDivisionByKode2Public(routePathId).then(
        response => {
          this.bidang = response.data[0];
        });

  }
};
</script>

<style>
body {
  font-family: "Roboto", sans-serif;
  font-size: 1rem;
  line-height: 1.5rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.bg-light {
  background: #fcfbff;
}

.section {
  padding-top: 50px;
  padding-bottom: 50px;
}
.section-head {
  margin: 0 0 30px;
}

.section-title {
  font-size: 1.75rem;
  font-weight: 700;
  text-transform: uppercase;
  margin: 0 0 15px;
}

.section-meta {
  font-size: 1rem;
  line-height: 25px;
  font-weight: 300;
  color: #777;
}

.section-body {
  font-weight: 300;
}
</style>
